import React from 'react';
import {Route, Routes} from "react-router-dom";
import Hero from "./pages/Hero";
import Header from "./components/Header";
import Info from "./pages/Info";
import  "./pages/Guide";
import Footer from "./components/Footer";
import { Analytics } from "@vercel/analytics/react"
import WaitlistForm from "./pages/WaitlistForm";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function usePageTracking() {
  const location = useLocation();

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-CSG151H2P1', {
        page_path: location.pathname + location.search,
      });
    }
  }, [location]);
}


const App = () => {
    return (
        <div>
            <Header/>
            <Routes>
                <Route path="/" element={<Hero/>} />
                <Route path="/about" element={<Info/>} />
                <Route path="/waitlist" element={<WaitlistForm/>} />
            </Routes>
            <Footer/>
            <Analytics />
        </div>
    );
};

export default App;